import React from 'react'
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { StringConvert } from '../components/StringConvert';

const truncateText = (text, maxLength) => {
  if (!text) return text;
  return text.length <= maxLength ? text : `${text.slice(0, maxLength)}...`;
};

const NewsCard = ({ data }) => {
  const { id, news_image, news_title, news_short_paragraph, news_slug, news_schedule } = data;
  const formattedDate = news_schedule ? dayjs(news_schedule).format('MMMM D, YYYY') : '';
  const truncatedText = truncateText(news_short_paragraph, 200);

  return (
    <div className='BlogsCard group relative overflow-hidden rounded-[1.5rem] border border-[#D4DEF1] bg-white shadow-custom transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_35px_rgba(18,38,63,0.10)]'>
      <Link className="BlogsCardMain flex flex-col gap-4 p-4 lg:flex-row lg:items-center" to={`/news/edit/${id}`}>
        <div className="BlogsCard__left w-full lg:w-[12rem] lg:flex-none">
          <img src={news_image} className='h-[11rem] w-full rounded-[1.25rem] object-cover lg:h-[8rem]' alt={news_title || "news"} />
        </div>
        <div className="BlogsCard__leftRight min-w-0 flex-1 lg:pr-4">
          <div className="mb-2 max-h-[3.1rem] overflow-hidden text-[1.1rem] capitalize font-MluvkaLight leading-[1.2] text-[#101828] lg:text-[1.25rem]">{news_title}</div>
          <div className='mb-2 text-sm text-[#667085]'>{formattedDate}</div>
          <div className='max-h-[4.9rem] overflow-hidden text-[.88rem] leading-[1.65] text-[#475467]'>{StringConvert(truncatedText)}</div>
          {news_slug && <div className='mt-2 text-xs text-[#7D8CA7]'>/{news_slug}</div>}
        </div>
        <div className="flex flex-row items-center justify-between gap-3 border-t border-[#EEF2F7] pt-4 lg:w-[10rem] lg:flex-col lg:items-end lg:justify-center lg:border-t-0 lg:pt-0 status-button">
          <span className="text-sm font-MluvkaBold text-[#0F172A]">Open</span>
          <span className="rounded-full bg-[#EFF4FD] px-4 py-2 text-sm font-MluvkaBold text-primary transition-colors group-hover:bg-primary group-hover:text-white">
            Edit
          </span>
        </div>
      </Link>
    </div>
  )
}

export default NewsCard
